import React from 'react';
import { RefreshCw, ChevronLeft, ChevronRight, Users } from 'lucide-react';
import UserCard from './UserCard';

function UserListMobile({ 
  users, 
  filteredUsers, 
  selectedUsers, 
  setSelectedUsers, 
  onRefresh, 
  onUserAction, 
  currentPage, 
  setCurrentPage, 
  totalPages, 
  itemsPerPage,
  theme,
  currentThemeName
}) {
  return (
    <div style={{
      display: 'none'
    }}
    className="md:hidden">
      <div style={{
        background: currentThemeName === 'dark'
          ? 'linear-gradient(135deg, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 0.9) 100%)'
          : currentThemeName === 'beige'
          ? 'linear-gradient(135deg, rgba(245, 245, 220, 0.9) 0%, rgba(250, 235, 215, 0.95) 100%)'
          : 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.98) 100%)',
        border: currentThemeName === 'dark'
          ? '1px solid rgba(59, 130, 246, 0.2)'
          : currentThemeName === 'beige'
          ? '1px solid rgba(139, 69, 19, 0.15)'
          : '1px solid rgba(59, 130, 246, 0.1)',
        borderRadius: 20,
        overflow: 'hidden',
        boxShadow: currentThemeName === 'dark'
          ? '0 8px 32px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(59, 130, 246, 0.1)'
          : currentThemeName === 'beige'
          ? '0 8px 32px rgba(139, 69, 19, 0.1), 0 0 0 1px rgba(139, 69, 19, 0.05)'
          : '0 8px 32px rgba(59, 130, 246, 0.08), 0 0 0 1px rgba(59, 130, 246, 0.05)',
        backdropFilter: 'blur(10px)',
        position: 'relative'
      }}>
        {/* Background gradient overlay */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: currentThemeName === 'dark'
            ? 'linear-gradient(135deg, rgba(59, 130, 246, 0.05) 0%, rgba(147, 51, 234, 0.03) 100%)'
            : currentThemeName === 'beige'
            ? 'linear-gradient(135deg, rgba(139, 69, 19, 0.03) 0%, rgba(160, 82, 45, 0.02) 100%)'
            : 'linear-gradient(135deg, rgba(59, 130, 246, 0.02) 0%, rgba(147, 51, 234, 0.01) 100%)',
          pointerEvents: 'none'
        }} />

        <div style={{
          padding: '20px',
          borderBottom: currentThemeName === 'dark'
            ? '1px solid rgba(255, 255, 255, 0.1)'
            : currentThemeName === 'beige'
            ? '1px solid rgba(139, 69, 19, 0.1)'
            : '1px solid rgba(59, 130, 246, 0.1)',
          position: 'relative',
          zIndex: 1
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <h3 style={{
              fontSize: 18,
              fontWeight: 600,
              color: currentThemeName === 'dark' ? 'white' : theme.text,
              margin: 0,
              display: 'flex',
              alignItems: 'center',
              gap: 10
            }}>
              <Users size={20} style={{
                color: currentThemeName === 'dark' ? '#93c5fd' : theme.textSecondary
              }} />
              Users ({filteredUsers.length})
            </h3>
            <button
              onClick={onRefresh}
              style={{
                padding: '8px 12px',
                borderRadius: 10,
                border: currentThemeName === 'dark'
                  ? '1px solid rgba(59, 130, 246, 0.2)'
                  : currentThemeName === 'beige'
                  ? '1px solid rgba(139, 69, 19, 0.15)'
                  : '1px solid rgba(59, 130, 246, 0.1)',
                background: currentThemeName === 'dark'
                  ? 'rgba(30, 41, 59, 0.8)'
                  : currentThemeName === 'beige'
                  ? 'rgba(245, 245, 220, 0.9)'
                  : 'rgba(255, 255, 255, 0.95)',
                color: currentThemeName === 'dark' ? '#93c5fd' : theme.text,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                fontSize: 12,
                fontWeight: 500,
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.borderColor = currentThemeName === 'dark' 
                  ? 'rgba(59, 130, 246, 0.3)' 
                  : currentThemeName === 'beige'
                  ? 'rgba(139, 69, 19, 0.2)'
                  : 'rgba(59, 130, 246, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.borderColor = currentThemeName === 'dark'
                  ? 'rgba(59, 130, 246, 0.2)'
                  : currentThemeName === 'beige'
                  ? 'rgba(139, 69, 19, 0.15)'
                  : 'rgba(59, 130, 246, 0.1)';
              }}
            >
              <RefreshCw size={16} />
              Refresh
            </button>
          </div>
        </div>

        <div style={{
          padding: '16px',
          position: 'relative',
          zIndex: 1
        }}>
          {filteredUsers.map((user) => (
            <UserCard
              key={user.id}
              user={user}
              selectedUsers={selectedUsers}
              setSelectedUsers={setSelectedUsers}
              onUserAction={onUserAction}
              theme={theme}
              currentThemeName={currentThemeName}
            />
          ))}
        </div>

        {/* Mobile Pagination */}
        {totalPages > 1 && (
          <div style={{
            padding: '16px 20px',
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            borderTop: currentThemeName === 'dark'
              ? '1px solid rgba(255, 255, 255, 0.1)'
              : currentThemeName === 'beige'
              ? '1px solid rgba(139, 69, 19, 0.1)'
              : '1px solid rgba(59, 130, 246, 0.1)',
            position: 'relative',
            zIndex: 1
          }}>
            <div style={{
              fontSize: 12,
              color: currentThemeName === 'dark' ? '#9ca3af' : theme.textSecondary,
              textAlign: 'center'
            }}>
              Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, users.length)} of {users.length} users
            </div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 16
            }}>
              <button
                onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                disabled={currentPage === 1}
                style={{
                  padding: '8px 12px',
                  borderRadius: 8,
                  border: currentThemeName === 'dark'
                    ? '1px solid rgba(59, 130, 246, 0.2)'
                    : currentThemeName === 'beige'
                    ? '1px solid rgba(139, 69, 19, 0.15)'
                    : '1px solid rgba(59, 130, 246, 0.1)',
                  background: currentThemeName === 'dark'
                    ? 'rgba(30, 41, 59, 0.8)'
                    : currentThemeName === 'beige'
                    ? 'rgba(245, 245, 220, 0.9)'
                    : 'rgba(255, 255, 255, 0.95)',
                  color: currentThemeName === 'dark' ? '#93c5fd' : theme.text,
                  cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                  opacity: currentPage === 1 ? 0.5 : 1,
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  if (currentPage !== 1) {
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.borderColor = currentThemeName === 'dark' 
                      ? 'rgba(59, 130, 246, 0.3)' 
                      : currentThemeName === 'beige'
                      ? 'rgba(139, 69, 19, 0.2)'
                      : 'rgba(59, 130, 246, 0.2)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (currentPage !== 1) {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.borderColor = currentThemeName === 'dark'
                      ? 'rgba(59, 130, 246, 0.2)'
                      : currentThemeName === 'beige'
                      ? 'rgba(139, 69, 19, 0.15)'
                      : 'rgba(59, 130, 246, 0.1)';
                  }
                }}
              >
                <ChevronLeft size={16} />
              </button>
              <span style={{
                fontSize: 14,
                fontWeight: 600,
                color: currentThemeName === 'dark' ? 'white' : theme.text,
                minWidth: '60px',
                textAlign: 'center'
              }}>
                {currentPage} / {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                disabled={currentPage === totalPages}
                style={{
                  padding: '8px 12px',
                  borderRadius: 8,
                  border: currentThemeName === 'dark'
                    ? '1px solid rgba(59, 130, 246, 0.2)'
                    : currentThemeName === 'beige'
                    ? '1px solid rgba(139, 69, 19, 0.15)'
                    : '1px solid rgba(59, 130, 246, 0.1)',
                  background: currentThemeName === 'dark'
                    ? 'rgba(30, 41, 59, 0.8)'
                    : currentThemeName === 'beige'
                    ? 'rgba(245, 245, 220, 0.9)'
                    : 'rgba(255, 255, 255, 0.95)',
                  color: currentThemeName === 'dark' ? '#93c5fd' : theme.text,
                  cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                  opacity: currentPage === totalPages ? 0.5 : 1,
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  if (currentPage !== totalPages) {
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.borderColor = currentThemeName === 'dark' 
                      ? 'rgba(59, 130, 246, 0.3)' 
                      : currentThemeName === 'beige'
                      ? 'rgba(139, 69, 19, 0.2)'
                      : 'rgba(59, 130, 246, 0.2)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (currentPage !== totalPages) {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.borderColor = currentThemeName === 'dark'
                      ? 'rgba(59, 130, 246, 0.2)'
                      : currentThemeName === 'beige'
                      ? 'rgba(139, 69, 19, 0.15)'
                      : 'rgba(59, 130, 246, 0.1)';
                  }
                }}
              >
                <ChevronRight size={16} />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserListMobile; 